import { Sprite } from './engine/assetLoader';
import { Renderable } from './engine/renderable';
import Vector2d from './engine/vector2d';
import { TILE_SIZE } from './gameObjects/pacman';
import State from './state';

export default class Lifebar implements Renderable<State> {
  public get name(): string {
    return 'Lifebar';
  }

  private lives: number = 0;

  constructor(private sprite: Sprite | undefined, private _player: number, private position: Vector2d) {
  }

  update(gameTime: number, state: State) {
    this.lives = state.players[this._player].lives;
  }

  render(gameTime: number, ctx: CanvasRenderingContext2D) {
    const { sprite, lives } = this;
    if (!sprite || !lives) {
      return;
    }

    ctx.save();
    ctx.translate(this.position.x * 16, this.position.y * 16);

    for (let i = lives; i > 0; i--) {
      ctx.drawImage(
        sprite.sprite,
        TILE_SIZE * 1,
        0,
        TILE_SIZE,
        TILE_SIZE,
        TILE_SIZE * i - TILE_SIZE,
        0,
        TILE_SIZE,
        TILE_SIZE
      );
    }

    ctx.restore();
  }
}
